<template lang="pug">
.container-projetos
  .card-projetos(
    v-for="projeto in projetos"
    :key="projeto.id"
  )
    .card-imagem
      img(:src="projeto.imagem" alt="Imagem do projeto")
    .card-conteudo
      .card-titulo {{ projeto.titulo }}
        .card-data
          LucideIcon(name="Calendar" :size="14")
          | {{ projeto.data }}
      .card-descricao {{ projeto.descricao }}
      Tags(:tags="projeto.tags")
    .card-btn-acoes
      ButtonPadrao(variant="negative" iconLeft)
        LucideIcon(slot="icon-left" name="Github" :size="16")
        | Código
      ButtonPadrao(iconLeft)
        LucideIcon(slot="icon-left" name="ExternalLink" :size="16")
        | Demo
</template>

<script>
import ButtonPadrao from '@/components/ui/ButtonPadrao.vue';
import Tags from '@/components/ui/Tags.vue';

export default {
  name: 'Projetos',
  components: {
    ButtonPadrao,
    Tags
  },
  data() {
    return {
      projetos: [
        {
          id: 1,
          titulo: 'E-commerce Platform',
          data: 'Maio 2023',
          descricao: 'Uma plataforma de e-commerce completa com carrinho, pagamentos e painel de administração.',
          tags: [
            { id: 1, name: 'Vue.js' },
            { id: 2, name: 'Node.js' },
            { id: 3, name: 'MongoDB' }
          ],
          imagem: require('@/assets/placeholder.svg')
        },
        {
          id: 2,
          titulo: 'Blog Pessoal',
          data: 'Abril 2023',
          descricao: 'Blog pessoal com editor de posts, comentários e autenticação.',
          tags: [
            { id: 1, name: 'Nuxt.js' },
            { id: 2, name: 'Express' }
          ],
          imagem: require('@/assets/placeholder.svg')
        },
        {
          id: 3,
          titulo: 'Dashboard Analytics',
          data: 'Março 2023',
          descricao: 'Dashboard para visualização de métricas em tempo real com gráficos interativos.',
          tags: [
            { id: 1, name: 'React' },
            { id: 2, name: 'Chart.js' },
            { id: 3, name: 'Firebase' }
          ],
          imagem: require('@/assets/placeholder.svg')
        },
        {
          id: 4,
          titulo: 'App de Tarefas',
          data: 'Fevereiro 2023',
          descricao: 'Aplicativo para gerenciamento de tarefas com notificações e sincronização em nuvem.',
          tags: [
            { id: 1, name: 'Flutter' },
            { id: 2, name: 'Dart' }
          ],
          imagem: require('@/assets/placeholder.svg')
        },
        {
          id: 5,
          titulo: 'Landing Page Produto',
          data: 'Janeiro 2023',
          descricao: 'Landing page responsiva para apresentação de produto e captação de leads.',
          tags: [
            { id: 1, name: 'HTML' },
            { id: 2, name: 'CSS' },
            { id: 3, name: 'JavaScript' }
          ],
          imagem: require('@/assets/placeholder.svg')
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.container-projetos{
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  
  .card-projetos {
    max-width: 440px;
    width: 100%;
    border: 1px solid $borderColor;
    border-radius: 8px;
    box-sizing: border-box;

    .card-imagem {
      width: 100%;
      height: 190px;
      background-color: #f0f0f0; // Placeholder for image
      border-radius: 8px 8px 0 0;
      overflow: hidden; // impede que a imagem ultrapasse a div

      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 8px 8px 0 0;
        transition: transform 0.3s ease;
        display: block;
      }

      &:hover img {
        transform: scale(1.08);
      }
    }

    .card-conteudo {
      width: 100%;
      padding: 24px;
      box-sizing: border-box;

      .card-titulo {
        font-size: 20px;
        font-weight: bold;
        color: $corVerdeClaro;
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .card-data {
          display: flex;
          align-items: center;
          color: $corValueInfoContato;
          font-size: 12px;
          font-weight: normal;

          svg {
            margin-right: 4px;
          }
        }
      }

      .card-descricao {
        font-size: 14px;
        color: $corValueInfoContato;
        margin-bottom: 16px;
      }
    }

    .card-btn-acoes {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 24px 24px;
      box-sizing: border-box;
      border-top: 1px solid $borderColor;
    }
  }
}
</style>